// extracted by mini-css-extract-plugin
export default {"unsaved-changes":"vOd4aCiqKiME1lxbaomN"};